import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { TypeLeaseDealsModel, TypeLeaseDealsPaths } from 'client/data/models/type-lease-deals';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { checkVehicleMatchesLeaseDeal } from 'site-modules/upper-funnel/utils/vehicle-lease-deal-match';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { LEASE_DEALS_PATH } from 'site-modules/shared/constants/lease-deals/routes';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES } from 'client/utils/image-helpers';
import { ShoppingLink } from 'site-modules/shared/components/shopping-link/shopping-link';

import './lease-deals-hidden-gems-link.scss';

const LeaseDealsHiddenGemsLinkUI = props => {
  const { leaseDeal, vehicle, className, dataTrackingParent } = props;

  if (!(leaseDeal?.payment && leaseDeal?.paymentMedian)) {
    return null;
  }

  const {
    modelYear: { makeName, modelName, year },
  } = vehicle;

  const belowAveragePayment = leaseDeal.paymentMedian - leaseDeal.payment;
  const dealDetails =
    belowAveragePayment > 0
      ? `${formatPriceString(belowAveragePayment)} below typical`
      : 'available for a limited time';

  return (
    <ShoppingLink
      label={`${formatPriceString(leaseDeal.payment)}/mo lease found!`}
      description={`This exceptionally rare deal is ${dealDetails}`}
      to={LEASE_DEALS_PATH}
      className={classnames('lease-deals-hidden-gems-link rounded-0 p-0_75 shadow-none', className)}
      linkContainerClassName="d-flex align-items-center flex-wrap"
      labelClassName="me-0_5 fw-bold"
      descriptionClassName="medium text-cool-gray-30"
      arrowClassName="icon-arrow-right3 cool-gray-40"
      icon={
        <Image
          lazy
          ariaHidden
          source={SOURCES.STATIC}
          imageId="/icons/lease-deals-gem.svg"
          className="object-fit-cover me-1"
          width={28}
          height={24}
        />
      }
      data-tracking-parent={`${dataTrackingParent}_oem_lease_deal`}
      data-tracking-id="view_hidden_gems_lease_deals"
      data-tracking-value={`${formatPriceString(leaseDeal.payment)} - ${year} ${makeName} ${modelName}`}
    />
  );
};

LeaseDealsHiddenGemsLinkUI.propTypes = {
  leaseDeal: PropTypes.shape({
    payment: PropTypes.number,
    paymentMedian: PropTypes.number,
  }),
  vehicle: TypeRankingsEntities.RankingVehicle.isRequired,
  className: PropTypes.string,
  dataTrackingParent: PropTypes.string,
};

LeaseDealsHiddenGemsLinkUI.defaultProps = {
  leaseDeal: undefined,
  className: undefined,
  dataTrackingParent: '',
};

export const LeaseDealsHiddenGemsLink = connectToModel(LeaseDealsHiddenGemsLinkUI, {
  leaseDeal: bindToPath(
    ({ type }) => TypeLeaseDealsPaths.getTypeLeaseDealsBodyEngineTypePath(type),
    TypeLeaseDealsModel,
    (leaseDeals, props) => {
      const {
        vehicle: { modelYear },
      } = props;

      return leaseDeals?.deals?.find(deal => checkVehicleMatchesLeaseDeal({ vehicle: modelYear, deal }));
    }
  ),
});

LeaseDealsHiddenGemsLink.propTypes = {
  type: PropTypes.string.isRequired,
  vehicle: TypeRankingsEntities.RankingVehicle.isRequired,
};
